<template>
    <b-card>
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
        <b-card class="card mb-3 mt-3">

          <!-- Name -->
           <b-card no-body class="simple-version-card">
            <b-row>
              <img
              style="max-width: 150px"
              class="thumbnail-size img-fluid img-thumbnail"
              id="iconPreview" v-show="iconPreviewOn"/>
               <div class="simple-appdetail">
                <h3>{{appData.name}}</h3>
              </div>
            </b-row>
          </b-card>
          <b-row>
            <b-col sm="7" md="10"><font class="text"> {{ appData.version }} </font> </b-col>
          </b-row>
          <b-row v-if="appData.file">
            <b-col sm="7" md="10"><font class="text"> {{ appData.file.lastModifiedDate }} </font> </b-col>
          </b-row>
          <hr class="my-1"/>
          <b-row>
            <b-col sm="7" md="7">
            <div class="form-group">
              <label for="formGroupExampleInput2">Release notes</label>
              <b-form-textarea
                class="form-control"
                placeholder="Enter release notes"
                rows="3"
                max-rows="8"
                v-model="appData.noteNew"
                :state="validateError.noteNew"
              ></b-form-textarea>
            </div>
            </b-col>
            <b-col>
            <div class="simple-os-right">
              <label class="text compat-label-title">Minimum OS</label>
              <div>{{ appData.compatibility }}</div>
              <div style="display:none;">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="usedPin"
                      name="checkbox-1"
                    >
                      Use PIN to download
                    </b-form-checkbox>
            </div>
            </div>
            </b-col>
          </b-row>
        </b-card>
        <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
        <b-card class="save-card">
            <b-button @click="goBack" variant="outline-danger">Back</b-button>
            <b-button class="btn-save-simple"
            @click="save"
            >Save</b-button>
            <!-- #339DAA !important -->
        </b-card>
    </b-card>
</template>
<script>
import AppVersionInfo from '@/models/appversion.js';
import AppInfo from '@/models/appinfo.js';
import Loading from '@/components/Loading';
export default {
  props: ['appMeta'],
  data () {
    return {
      newApp: false,
      iconPreviewOn: false,
      categories: [{ value: 'Life Style', text: 'Life Style' }, { value: 'Others', text: 'Others' }],
      fileName: '',
      appData: {},
      isEditing: true,
      isCreate: false,
      usedPin: true,
      validateError: {
        noteNew: null
      },
      errorMessage: '',
      isLoading: false,
      altImage: require('@/assets/notavailable.png')
    };
  },
  methods: {
    save () {
      const appVersionInfo = new AppVersionInfo(this.appData);
      const appInfo = new AppInfo(this.appData);
      // console.log('Version Form : ', appVersionInfo);
      // console.log('AppForm : ', appInfo);
      if (this.isValidateError()) {
        this.errorMessage = 'validate error!';
      } else {
        const bodyFormData = new FormData();
        // Thumbnail Base64 to file
        const block = appVersionInfo.thumbnail.split(';');
        const contentType = block[0].split(':')[1];
        const realData = block[1].split(',')[1];
        bodyFormData.append('thumbnail', this.b64toBlob(realData, contentType));
        bodyFormData.append('file', appVersionInfo.file);
        bodyFormData.append('name', appInfo.name);
        bodyFormData.append('platform', appInfo.platform.toLowerCase());
        bodyFormData.append('bundleId', appInfo.bundleId);
        bodyFormData.append('description', appVersionInfo.noteNew);
        bodyFormData.append('version', appVersionInfo.version);
        bodyFormData.append('noteNew', appVersionInfo.noteNew);
        bodyFormData.append('compatibility', appVersionInfo.compatibility);
        bodyFormData.append('category', appVersionInfo.category);
        this.isLoading = true;
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/upload-app', bodyFormData)
          .then(response => {
            // console.log
            this.isEditing = false;
            const data = response.data.data;
            let app = data.app;
            sessionStorage.setItem('app', JSON.stringify(app));
            this.$router.push({ name: 'apps2-details-2', params: { id: app.id } });
          })
          .catch(error => { this.errorMessage = error.response && error.response.data && error.response.data.data ? error.response.data.data : error.message; })
          .finally(() => { this.isLoading = false; });
      }
    },
    isValidateError () {
      // eheck object is alive
      if (0 === Object.keys(this.appData).length && this.appData.constructor === Object) return true;

      // start validate field
      if (!this.appData.noteNew || 0 === this.appData.noteNew.length) {
        this.validateError.noteNew = false;
      } else {
        this.validateError.noteNew = null;
      }
      let key = Object.keys(this.validateError).find(k => false === this.validateError[k]);
      return !!key;
    },
    goBack () {
      this.$router.go(-1);
    },
    preventNav (event) {
      if (!this.isEditing) return;
      event.preventDefault();
      event.returnValue = '';
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      /**
       *  Read Me !!
       * Ref: https://ourcodeworld.com/articles/read/322/how-to-convert-a-base64-image-into-a-image-file-and-upload-it-with-an-asynchronous-form-using-jquery
       *
       * */

      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  },
  watch: {
    'appData.category' () {
      console.log(this.appData.category);
    }
  },
  mounted () {
    const simpleApp = this.appMeta;
    console.log('APP => ', simpleApp);
    if (simpleApp) {
      this.appData = simpleApp;
      // check create or update
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app?name=' + this.appData.name)
        .then(response => {
          const data = response.data.data;
          if (data) {
            if (data.appStores.length <= 0) {
              this.isCreate = true;
            }
          }
          if (this.appData && this.appData.thumbnail) {
            this.iconPreviewOn = true;
            document.getElementById('iconPreview').src = simpleApp.thumbnail;
          }
        })
        .catch(error => {
          console.log(error);
        });

      // set default value
      this.appData.category = 'Others';
    } else {
      this.isEditing = false;
      this.$router.go(-1);
    }
  },
  beforeMount () {
    /**
     * NOTE *** can't custom message confirm alert because browser will ignore.
     * ref: https://stackoverflow.com/questions/38879742/is-it-possible-to-display-a-custom-message-in-the-beforeunload-popup
     */
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav);
    });
  },
  beforeRouteLeave (to, from, next) {
    if (this.isEditing) {
      if (!window.confirm('Leave without saving?')) {
        return;
      }
    }
    next();
  },
  components: {
    'app-loading': Loading
  }
};
</script>
<style scoped src="@/assets/css/appstore-simform.css"/>
